import randomString from '@/utils/random-string';

interface IconAttendeeGradientProps {
  /** id must be unique for each instance */
  id?: string;
  size?: number;
  from?: string;
  to?: string;
}

const IconAttendeeGradient = ({ id: _id, size = 22, from = '#5AE4FF', to = '#A7FF7B' }: IconAttendeeGradientProps) => {
  const id = _id || `icon-attendee-gradient-${randomString(6)}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M11.7013 6.11406L14.0513 3.7474C14.1846 3.61406 14.343 3.5474 14.5263 3.5474C14.7096 3.5474 14.868 3.61406 15.0013 3.7474C15.1346 3.88073 15.2013 4.03906 15.2013 4.2224C15.2013 4.40573 15.1346 4.56406 15.0013 4.6974L12.168 7.53073C12.0346 7.66406 11.8791 7.73073 11.7013 7.73073C11.5235 7.73073 11.368 7.66406 11.2346 7.53073L9.81797 6.11406C9.68464 5.98073 9.61797 5.8224 9.61797 5.63906C9.61797 5.45573 9.68464 5.2974 9.81797 5.16406C9.9513 5.03073 10.1069 4.96406 10.2846 4.96406C10.4624 4.96406 10.618 5.03073 10.7513 5.16406L11.7013 6.11406ZM6.0013 7.9974C5.26797 7.9974 4.64019 7.73629 4.11797 7.21406C3.59575 6.69184 3.33464 6.06406 3.33464 5.33073C3.33464 4.5974 3.59575 3.96962 4.11797 3.4474C4.64019 2.92517 5.26797 2.66406 6.0013 2.66406C6.73464 2.66406 7.36241 2.92517 7.88464 3.4474C8.40686 3.96962 8.66797 4.5974 8.66797 5.33073C8.66797 6.06406 8.40686 6.69184 7.88464 7.21406C7.36241 7.73629 6.73464 7.9974 6.0013 7.9974ZM0.667969 11.9974V11.4641C0.667969 11.0863 0.765191 10.7391 0.959635 10.4224C1.15408 10.1057 1.41241 9.86406 1.73464 9.6974C2.42352 9.35295 3.12352 9.09462 3.83464 8.9224C4.54575 8.75017 5.26797 8.66406 6.0013 8.66406C6.73464 8.66406 7.45686 8.75017 8.16797 8.9224C8.87908 9.09462 9.57908 9.35295 10.268 9.6974C10.5902 9.86406 10.8485 10.1057 11.043 10.4224C11.2374 10.7391 11.3346 11.0863 11.3346 11.4641V11.9974C11.3346 12.3641 11.2041 12.678 10.943 12.9391C10.6819 13.2002 10.368 13.3307 10.0013 13.3307H2.0013C1.63464 13.3307 1.32075 13.2002 1.05964 12.9391C0.798524 12.678 0.667969 12.3641 0.667969 11.9974Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="0.667969" y1="7.9974" x2="15.2013" y2="7.9974" gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconAttendeeGradient;
